import React from 'react'
import { PrimaryCheckbox } from 'components/Shared/PrimaryCheckbox'
import { useTranslation } from 'react-i18next'

export default function LabeledPrimaryCheckbox ({ label, disabled, ...rest }) {
  const { t } = useTranslation()

  return <label className={disabled ? '':'cursorPointer'}>
    <PrimaryCheckbox
      disabled={disabled}
      {...rest}
    />
    {t(label)}
  </label>
}